import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/publishers/advantages/image.png")